export default "__VITE_ASSET__C979LgvW__"